import {Box, Skeleton} from '@viptech/react-components'

export function PhotoFrameSkeleton() {
  return (
    <Box width='fit-content' height='fit-content' padding='8px' border='2px solid #D0D5DD' backgroundColor='#F2F4F7'>
      <Box width='128px' display='flex' rowGap='8px' direction='column'>
        <Skeleton width='100px' height='12px' borderRadius='8px' />

        <Skeleton width='128px' height='130px' />

        <Box>
          <Box display='flex' justify='space-between'>
            <Skeleton width='48px' height='10px' borderRadius='8px' />
            <Skeleton width='32px' height='10px' borderRadius='8px' />
          </Box>
          <Skeleton width='48px' height='10px' borderRadius='8px' />
        </Box>
      </Box>
    </Box>
  )
}

export function PhotoFrameSkeletonMap() {
  return new Array(27).fill(null).map((_, index) => <PhotoFrameSkeleton key={index} />)
}
